import ActivationMessage, {ActivationMessageProps, ActivationMessageType} from "./ActivationMessage";

interface ActivationSuccessProps extends Omit<ActivationMessageProps, "type"> {
  type?: ActivationMessageType;
}

export default function ActivationSuccess(props: ActivationSuccessProps) {
  return (
    <ActivationMessage
      {...props}
      type={ActivationMessageType.SUCCESS}
    />
  );
}